if (!window.Eurus || !window.Eurus.loadedScript) {
  window.Eurus = window.Eurus || {};
  window.Eurus.loadedScript = window.Eurus.loadedScript || new Set();
}

if (!window.Eurus.loadedScript.has('stamped-rewards-points.js')) {
  window.Eurus.loadedScript.add('stamped-rewards-points.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xStampedRewards', () => ({
        customerTier: 'bronze',
        tierMultipliers: {
          gold: 2,
          silver: 1.5,
          bronze: 1
        },

        init() {
          // Get customer tier from data attribute
          const tierData = this.$el.dataset.customerTier;
          if (tierData && tierData !== '') {
            this.customerTier = tierData.toLowerCase();
          }

          // Initial calculation
          this.updateRewardsPoints();

          // Listen for variant changes
          this.setupVariantChangeListener();
        },

        setupVariantChangeListener() {
          this.priceObserver = new MutationObserver(() => {
            this.updateRewardsPoints();
          });

          // IMPORTANT: Only observe the target price element inside .main-product-price
          // This prevents side cart prices from interfering with rewards points calculation
          const targetPriceEl = document.querySelector('.main-product-price .target-price');
          if (targetPriceEl) {
            this.priceObserver.observe(targetPriceEl, {
              attributes: true,
              attributeFilter: ['data-original-price']
            });
          }

          // Store event handler reference for cleanup
          this.variantChangeHandler = (event) => {
            if (event.detail && event.detail.price) {
              this.updateRewardsPoints(event.detail.price);
            } else {
              this.updateRewardsPoints();
            }
          };

          // Also listen for Alpine variant update events
          document.addEventListener('variant:changed', this.variantChangeHandler);

          // Cleanup on destroy
          this.$watch('$el', (value) => {
            if (!value) {
              if (this.priceObserver) {
                this.priceObserver.disconnect();
              }
              if (this.variantChangeHandler) {
                document.removeEventListener('variant:changed', this.variantChangeHandler);
              }
            }
          });
        },

        updateRewardsPoints(priceFromEvent = null) {
          const priceForRewardsEl = document.getElementById('priceForRewardsPoints');
          const rewardsContainer = document.querySelector('.stamped-io-rewards-points');

          if (!priceForRewardsEl || !rewardsContainer) {
            return;
          }

          let priceInCents;

          if (priceFromEvent !== null && !isNaN(priceFromEvent) && priceFromEvent > 0) {
            priceInCents = priceFromEvent;
          } else {
            const targetPriceEl = document.querySelector('.main-product-price .target-price');
            if (!targetPriceEl) return;

            priceInCents = parseInt(targetPriceEl.getAttribute('data-original-price'));
          }

          if (isNaN(priceInCents) || priceInCents <= 0) {
            rewardsContainer.style.display = 'none';
            return;
          }

          // Calculate points based on tier
          const multiplier = this.tierMultipliers[this.customerTier] || 1;
          const priceInDollars = priceInCents / 100;
          const points = Math.floor(priceInDollars * multiplier);

          // Update the inner span with points value
          if (points > 0) {
            priceForRewardsEl.textContent = points;
            rewardsContainer.classList.remove('hidden');
          } else {
            rewardsContainer.classList.add('hidden');
          }
        }
      }));
    });
  });
}
